import { Paper, PaperProps } from '@material-ui/core'
import React, { FC } from 'react'
import Draggable from 'react-draggable'

const DraggablePaper: FC<PaperProps> = (props: PaperProps) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    )
}

export default DraggablePaper
